// Leads widget helper functions and data
import { widgetInitialData } from "../widgets.helpers";
import { LeadsDrawers } from "./widgets.leads.types";

const drawers: LeadsDrawers = {};

export const leadsInitialData = { ...widgetInitialData, drawers };
